import atomBankLogo from '@/assets/logos/Atom Bank.jpg';
import barclaysLogo from '@/assets/logos/Barclays.png';
import cahnLogo from '@/assets/logos/Caribbean and African Health Network (CAHN).png';
import fghLogo from '@/assets/logos/FGH.png';
import incomeMaxLogo from '@/assets/logos/Income Max.png';
import makeLifeBetterLogo from '@/assets/logos/Make Life Better.png';
import metroBankLogo from '@/assets/logos/Metro Bank.jpg';
import nationalDebtlineLogo from '@/assets/logos/National Debtline.png';
import payPlanLogo from '@/assets/logos/PayPlan.svg';
import powerNiLogo from '@/assets/logos/Power NI.jpg';
import rundlesLogo from '@/assets/logos/Rundles.png';
import stopLoanSharksLogo from '@/assets/logos/Stop Loan Sharks.png';
import unitedUtilitiesLogo from '@/assets/logos/United Utilities.png';
import v12RetailFinanceLogo from '@/assets/logos/V12 Retail Finance.png';
import vulnerabilityRegistrationServiceLogo from '@/assets/logos/Vulnerability Registration Service.svg';
import wessexWaterLogo from '@/assets/logos/Wessex Water.png';
import whippsEnforcementLogo from '@/assets/logos/Whipps Enforcement.png';

export const logoMap: Record<string, string> = {
  // Atom Bank
  'atom bank': atomBankLogo,
  'atom': atomBankLogo,

  // Barclays group
  'barclays': barclaysLogo,
  'barclays bank': barclaysLogo,
  'barclays bank uk': barclaysLogo,
  'barclays business': barclaysLogo,
  'barclays money management': barclaysLogo,
  'barclays mortgages': barclaysLogo,
  'barclays partner finance': barclaysLogo,

  // Caribbean and African Health Network (CAHN)
  'caribbean and african health network (cahn)': cahnLogo,
  'caribbean and african health network': cahnLogo,
  'cahn': cahnLogo,

  // FGH (Freemans Grattan Holdings) group
  'fgh': fghLogo,
  'bonprix': fghLogo,
  'curvissa': fghLogo,
  'clearance365': fghLogo,
  'freemans': fghLogo,
  'freemans grattan holdings (fgh)': fghLogo,
  'freemans grattan holdings': fghLogo,
  'grattan': fghLogo,
  'kaleidoscope': fghLogo,
  'look again': fghLogo,
  'swimwear365': fghLogo,
  'witt': fghLogo,

  // Income Max
  'income max': incomeMaxLogo,
  'incomemax': incomeMaxLogo,

  // Make Life Better
  'make life better': makeLifeBetterLogo,
  'makelifebetter': makeLifeBetterLogo,

  // Metro Bank
  'metro bank': metroBankLogo,
  'metrobank': metroBankLogo,

  // National Debtline
  'national debtline': nationalDebtlineLogo,
  'national debt line': nationalDebtlineLogo,
  'nationaldebtline': nationalDebtlineLogo,

  // PayPlan
  'payplan': payPlanLogo,
  'pay plan': payPlanLogo,

  // Power NI
  'power ni': powerNiLogo,
  'powerni': powerNiLogo,

  // Rundles
  'rundles': rundlesLogo,

  // Stop Loan Sharks
  'stop loan sharks': stopLoanSharksLogo,
  'stoploansharks': stopLoanSharksLogo,

  // United Utilities
  'united utilities': unitedUtilitiesLogo,
  'unitedutilities': unitedUtilitiesLogo,

  // V12 Retail Finance
  'v12 retail finance': v12RetailFinanceLogo,
  'v12 retail finance limited': v12RetailFinanceLogo,
  'v12 retail finance ltd': v12RetailFinanceLogo,
  'v12': v12RetailFinanceLogo,

  // Vulnerability Registration Service
  'vulnerability registration service': vulnerabilityRegistrationServiceLogo,
  'vulnerability registration service (vrs)': vulnerabilityRegistrationServiceLogo,
  'vrs': vulnerabilityRegistrationServiceLogo,

  // Wessex Water
  'wessex water': wessexWaterLogo,
  'wessexwater': wessexWaterLogo,

  // Whipps Enforcement
  'whipps enforcement': whippsEnforcementLogo,
  'whipps': whippsEnforcementLogo
};

/**
 * Returns the logo URL for a given lender/creditor organisation name.
 * If no logo is matched in `logoMap`, returns null.
 */
export function getLenderLogo(name?: string | null): string | null {
  if (!name) return null;
  const lower = name.trim().toLowerCase();
  if (logoMap[lower]) {
    return logoMap[lower];
  }
  const sanitized = lower.replace(/[,.]/g, '').trim();
  if (logoMap[sanitized]) {
    return logoMap[sanitized];
  }
  const strippedSuffix = lower.replace(/\s+(plc|ltd|limited|llp|group)(\s+(plc|ltd|limited|llp))?$/i, '').trim();
  if (logoMap[strippedSuffix]) {
    return logoMap[strippedSuffix];
  }
  return null;
}
